import type { Company, Hero as HeroContent, Practice } from '../api/types';
import { LoopRing } from './LoopRing';
import styles from './Hero.module.css';

interface HeroProps {
  hero: HeroContent;
  company: Company;
  practices: Practice[];
}

export function Hero({ hero, company, practices }: HeroProps) {
  return (
    <section className={styles.hero}>
      <div className={`shell ${styles.inner}`}>
        <div>
          <p className="eyebrow">{hero.eyebrow}</p>

          <h1 className={styles.headline}>
            {hero.headline.lead}
            <em>{hero.headline.accent}</em>
            {hero.headline.trail}
          </h1>

          <p className={`lead ${styles.body}`}>{hero.body}</p>

          <div className={styles.actions}>
            <a className="btn btnPrimary" href={hero.primaryAction.href}>
              {hero.primaryAction.label}
            </a>
            <a className="btn btnGhost" href={hero.secondaryAction.href}>
              {hero.secondaryAction.label}
            </a>
          </div>

          <div className={styles.meta}>
            <span className={styles.availability} data-open={company.availability.open}>
              <i aria-hidden="true" />
              {company.availability.label}
            </span>
            <span>{practices.map((practice) => practice.tag).join(' · ')}</span>
            <span>{company.location}</span>
          </div>
        </div>

        <LoopRing
          practices={practices}
          coreLabel={hero.loopCore}
          defaultNote={hero.loopNote}
        />
      </div>
    </section>
  );
}
